export default __webpack_public_path__ + "static/media/logo-small-v1.49e6dcca.png";